import type { LayoutChangeEvent } from 'react-native';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { colors } from '../theme';
import { inter400, inter500, isWeb } from '../utils/platform';
import { RECOMMENDATIONS } from '../utils/recommendations-data';


type RecommendationsSectionProps = {
  onLayout: (event: LayoutChangeEvent) => void;
  onPressTitle: () => void;
};

export function RecommendationsSection({ onLayout, onPressTitle }: RecommendationsSectionProps) {
  return (
    <View nativeID="recommendations" onLayout={onLayout} style={styles.recommendationsSection}>
      <Pressable onPress={onPressTitle} style={styles.sectionTitleLink}>
        <Text style={styles.sectionTitle}>Recommendations</Text>
      </Pressable>

      <View style={styles.recommendationsList}>
        {RECOMMENDATIONS.map((recommendation) => (
          <View key={recommendation.name} style={styles.recommendationCard}>
            <View style={styles.recommendationTitle}>
              <Text style={styles.recommendationName}>{recommendation.name}</Text>
              <Text style={styles.metaText}>{recommendation.role}</Text>
            </View>
            <Text style={styles.paragraph}>"{recommendation.quote}"</Text>
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  recommendationsSection: {
    gap: 32,
    paddingVertical: 30,
  },
  sectionTitleLink: {
    alignSelf: 'flex-start',
    ...(isWeb
      ? {
        cursor: 'pointer',
      }
      : null),
  },
  sectionTitle: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 20,
    fontWeight: '500',
    lineHeight: 24,
  },
  recommendationsList: {
    gap: 48,
    width: '100%',
  },
  recommendationCard: {
    borderColor: colors.border,
    borderLeftWidth: 1,
    gap: 32,
    overflow: 'hidden',
    paddingLeft: 16,
    width: '100%',
  },
  recommendationTitle: {
    gap: 8,
    width: '100%',
  },
  recommendationName: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 19.2,
  },
  metaText: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 19.6,
  },
  paragraph: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 22.4,
  },
});
